module.exports = __webpack_public_path__ + "img/finland-tuberculosis-male.7fd4380a.png";